import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import AuthThemeProvider from "./theme/AuthThemeProvider";
import ThemeModeProvider from "./theme/ThemeModeProvider";
import {
  ActiveAnnouncementsPage,
  AnnouncementApprovalPage,
  CustomerOverviewActivityPage,
  CustomerOverviewInfoPage,
  CustomersClientsPage,
  DashboardHomePage,
  GuestAnnouncementsPage,
  ItemsPage,
  UserApprovalsPage,
} from "./pages/admin/AdminPages";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <AuthThemeProvider>
              <Login />
            </AuthThemeProvider>
          }
        />
        <Route
          path="/signup"
          element={
            <AuthThemeProvider>
              <Signup />
            </AuthThemeProvider>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <ThemeModeProvider>
              <Dashboard />
            </ThemeModeProvider>
          }
        >
          <Route index element={<Navigate to="home" replace />} />
          <Route path="home" element={<DashboardHomePage />} />
          <Route path="customers/clients" element={<CustomersClientsPage />} />
          <Route path="customers/overview/info" element={<Navigate to="/dashboard/customers/clients" replace />} />
          <Route path="customers/overview/activity" element={<Navigate to="/dashboard/customers/clients" replace />} />
          <Route path="customers/overview/:userId/info" element={<CustomerOverviewInfoPage />} />
          <Route path="customers/overview/:userId/activity" element={<CustomerOverviewActivityPage />} />
          <Route path="customers/user-approvals" element={<UserApprovalsPage />} />
          <Route path="announcements/approval" element={<AnnouncementApprovalPage />} />
          <Route path="announcements/active" element={<ActiveAnnouncementsPage />} />
          <Route path="announcements/guest" element={<GuestAnnouncementsPage />} />
          <Route path="announcements/buyer" element={<Navigate to="/dashboard/announcements/approval" replace />} />
          <Route path="announcements/broker" element={<Navigate to="/dashboard/announcements/active" replace />} />
          <Route path="properties" element={<Navigate to="/dashboard/items" replace />} />
          <Route path="items" element={<ItemsPage />} />
          <Route path="settings" element={<Navigate to="/dashboard/items" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;